import { api } from '@/lib/api/client'

/** `DELETE /notifications/{notification}` dismisses a notification. */
export async function deleteNotification(id: number): Promise<void> {
  await api.delete(`/notifications/${id}`)
}
